import { render, staticRenderFns } from "./SearchResposible.vue?vue&type=template&id=7055522c"
import script from "./SearchResposible.vue?vue&type=script&lang=js"
export * from "./SearchResposible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports